import React from "react";
import { Navigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { LoadingSpinner } from "../common/LoadingSpinner";

const ProtectedRoute = ({ children }) => {
  const { instance, inProgress } = useMsal();
  const activeAccount = instance.getActiveAccount();

  // While MSAL is initializing or authentication is in progress
  if (inProgress === "startup" || inProgress === "login") {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '40vh' }}>
        <LoadingSpinner size="large" color="primary" />
      </div>
    );
  }

  // If there's no active account, redirect to login page
  if (!activeAccount) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated: render the children
  return children;
};

export default ProtectedRoute;